const C = require("../constants");

const selectCategory = (data) => {
    return {
        type: C.CATEGORY_SELECT,
        data
    }
};

export {selectCategory};


// WEBPACK FOOTER //
// ./src/actions/CategorySelectActions.js